var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Track") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-811.000000, -427.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Track",
    transform: "translate(811.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.707,11.6055 L8.393,0.2925 C8.002,-0.0975 7.369,-0.0975 6.979,0.2925 C5.278,1.9935 4.342,4.2525 4.342,6.6565 C4.342,9.0605 5.278,11.3205 6.979,13.0195 C8.679,14.7195 10.939,15.6565 13.343,15.6565 C15.747,15.6565 18.007,14.7195 19.707,13.0195 C19.894,12.8325 20,12.5775 20,12.3125 C20,12.0475 19.894,11.7925 19.707,11.6055",
    id: "Fill-565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6445,5.6445 L16.3935,4.8955 C16.5855,4.9575 16.7875,4.9995 17.0005,4.9995 C18.1035,4.9995 19.0005,4.1035 19.0005,2.9995 C19.0005,1.8955 18.1035,0.9995 17.0005,0.9995 C15.8945,0.9995 15.0005,1.8955 15.0005,2.9995 C15.0005,3.1425 15.0165,3.2815 15.0445,3.4155 L14.2305,4.2305 L15.6445,5.6445 Z",
    id: "Fill-566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.707,12.293 C4.48,12.065 4.156,11.962 3.84,12.013 C3.523,12.064 3.25,12.266 3.106,12.553 L0.106,18.553 C-0.049,18.863 -0.033,19.231 0.149,19.526 C0.332,19.82 0.653,20 1,20 L10,20 C10.404,20 10.769,19.757 10.924,19.383 C11.079,19.009 10.993,18.579 10.707,18.293 L4.707,12.293 Z",
    id: "Fill-567"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.f21d3a8a56b830c9420c31088d532836.svg";
export { ForwardRef as ReactComponent };